const NextI18Next = require('next-i18next').default

const NextI18NextInstance = new NextI18Next({
  preload: ['vi'],
  defaultNS: 'common',
  defaultLanguage: 'vi',
  serverLanguageDetection: true,
  otherLanguages: ['en'],
  keySeparator: false,
  nsSeparator: false,
  detection: {
    order: ['querystring'],
  },
  localePath: 'public/static/locales'
})

module.exports = NextI18NextInstance
